import { render, staticRenderFns } from "./LiveConsultMediaButton.vue?vue&type=template&id=a2506f0a&scoped=true"
import script from "./LiveConsultMediaButton.vue?vue&type=script&lang=js"
export * from "./LiveConsultMediaButton.vue?vue&type=script&lang=js"
import style0 from "./LiveConsultMediaButton.vue?vue&type=style&index=0&id=a2506f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2506f0a",
  null
  
)

export default component.exports